<div class="flex flex-row justify-end p-4">
  <!-- <app-theme-switcher></app-theme-switcher> -->
</div>

<div class="mx-auto my-4 w-full max-w-[800px] px-4 md:w-4/5">
  <app-login></app-login>
</div>
